module.exports = __webpack_public_path__ + "img/JZ.dfb81f53.png";